import React, { useState, useEffect, useRef } from "react";
import Select from "../../ui/PortalSelect";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import "antd/dist/antd.css";
import { DatePicker } from "antd";
import Swal from "sweetalert2";
import moment from "moment";
import { Calendar } from 'antd';
// import MultiRangeSlider from "multi-range-slider-react";
import RangeSlider from "react-bootstrap-range-slider";
import axios from "axios";
import { baseURL } from "../backend_url";
import { formatDate, formatDate_withTime } from "../commonFunctions";
// import { MDBDataTable } from 'mdbreact';
import { Alert } from "@mui/material";
import Button from "@mui/material/Button";
import { Preview } from "@mui/icons-material";
import { MDBDataTable } from "mdbreact";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdbreact";
import { isEmpty } from 'lodash';
import {
  getUserAccountType,
  loadAccessibleCompanies,
  readSessionUser,
} from '../accountAccess';
import { expectExactPayload, requestErrorMessage } from '../mutationContract';

const options = [
  { value: "Select SIP", label: "Select SIP" },
  { value: "ECAR", label: "ECAR" },
  { value: "CCAR", label: "CCAR" },
];

export default function DataTable({ accessType }) {

  const [columnData, setColumnData] = useState([]);
  const [fromDate, setFromDate] = useState(new Date())
  const [toDate, setToDate] = useState(new Date())
  const [rowsData, setRowsData] = useState([]);
  const [rateInfoDetails, setRateInfoDetails] = useState([]);
  const [range, setRange] = useState({ min: 10, max: 100 });
  const [selectedOption, setSelectedOption] = useState("");
  const [locationDetail, setLocationDetail] = useState([{}]);
  const [locationName, setLocationName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [temp_company_id, settemp_company_id] = useState("");
  const [sippCodeList, setSippCodeList] = useState([]);
  const [selectedSippCode, setSelectedSippCode] = useState("");
  const [sippCodeOptions, setSippCodeOptions] = useState("");
  const [competesSippCodeList, setCompetesSippCodeList] = useState([]);
  const [selectedCompetesSippCode, setSelectedCompetesSippCode] = useState("");
  const [numDropdowns, setNumDropdowns] = useState(1);
  const [companyName, setCompanyName] = useState("");
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [locationId, setLocationId] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [companyDetail, setcompanyDetail] = useState([]);
  const [competitorsGrid, setCompetitorsGrid] = useState([
    ["", "", "", "", ""],
  ]);
  const [availableCarClasses, setAvailableCarClasses] = useState([{}]);
  const [saving, setSaving] = useState(false);

  //Option for Location name
  // const locationNameOptions = locationDetail.map((value) => ({
  //   value: value.location_name,
  //   label: value.location_name,
  // }));

  const locationNameOptions = locationDetail.map((value) => (
    { value: value.location_name, label: value.location_name === undefined ? value.location_name : value.location_name + " - " + value.location_id.toString().trim().split("-")[1] }
  ));

  const handleInputChangeLocationName = (characterEntered) => {
    // const filtredId = locationDetail.filter((item) => item.)
    console.log(characterEntered);
    setLocationName(characterEntered.value);
    // setCompanyId();
  };

  // const handleInputChangeSippCode = (characterEntered, i) => {

  const getTheDataByDateandLocation = () => {
    let from_date = ''
    let temp_location_id = ''
    if (locationName != "") {
      from_date = new Date(fromDate).toDateString()
      setNumDropdowns(1);
      setCompetitorsGrid([["", "", "", "", ""]]);
      temp_location_id = locationDetail.filter((loc) => (loc.location_name === locationName)).map((val) => val.location_id)
      setLocationId(temp_location_id);

      axios
        .get(
          baseURL + "/get_all_minumum_rate_coll/" + temp_location_id + "*" + from_date
          + '?companyNumber=' + encodeURIComponent(company_id.toString())
        )
        .then((res) => {
          setNumDropdowns(res.data.selected_items.length);
          setCompetitorsGrid(res.data.selected_items);
          const usedCarClasses = res.data.selected_items
            .filter(row => row[0].value)
            .map(row => row[0].value);

          const newAvailableCarClasses = selectedSippCodeNameOptions.filter(
            option => !usedCarClasses.includes(option.value)
          );
          // Add back deselected car classes to newAvailableCarClasses
          res.data.selected_items.forEach(row => {
            if (!row[0].value) {
              newAvailableCarClasses.push({ value: row[0].label, label: row[0].label });
            }
          });
          setAvailableCarClasses(newAvailableCarClasses.filter(option => option.value !== 'undefined'));
          console.log("im at inside availableCarClasses");
          console.log(availableCarClasses);
        });
    } else {
      Swal.fire("Please select the Location")
    }
  }


  const handleInputChangeSippCode = (characterEntered, i) => {
    let arr1 = [...competitorsGrid];
    arr1[i][0] = characterEntered;

    const usedCarClasses = arr1
      .filter((row, index) => index !== i && row[0].value)
      .map(row => row[0].value);
    if (characterEntered) {
      usedCarClasses.push(characterEntered.value);
    }
    const newAvailableCarClasses = selectedSippCodeNameOptions.filter(
      option => !usedCarClasses.includes(option.value)
    );
    if (!characterEntered) {
      newAvailableCarClasses.push({ value: arr1[i][0].value, label: arr1[i][0].value });
    }
    setCompetitorsGrid(arr1);
    setAvailableCarClasses(newAvailableCarClasses);
  };

  const handleInputChangeCompanyName = characterEntered => {
    setCompanyName(characterEntered.value);
  };

  const handleInputChangeCappedDaily = (characterEntered, i) => {
    let arr1 = [...competitorsGrid];
    arr1[i][1] = characterEntered;
    setCompetitorsGrid(arr1);
  };

  const handleInputChangeCappedWeekly = (characterEntered, i) => {
    let arr1 = [...competitorsGrid];
    arr1[i][2] = characterEntered;
    setCompetitorsGrid(arr1);
  };

  const handleInputChangeCappedXDay = (characterEntered, i) => {
    let arr1 = [...competitorsGrid];
    arr1[i][3] = characterEntered;
    setCompetitorsGrid(arr1);
  };

  const handleInputChangeDailyRate = (characterEntered, i) => {
    let arr1 = [...competitorsGrid];
    arr1[i][4] = characterEntered;
    setCompetitorsGrid(arr1);
  };

  const selectedSippCodeNameOptions = sippCodeList.map((value) => ({
    value: value.SIPP_code,
    label: value.SIPP_code,
  }));

  console.log("selectedSippCodeNameOptions");
  console.log(selectedSippCodeNameOptions);


  const companyNameOptions = companyDetail.map((value) => (
    { value: value.company_name, label: value.company_name }
  ));

  useEffect(() => {
    if (companyDetail && companyName) {

      let obj_company_detail = companyDetail.filter(
        (value) => value.company_name === companyName
      )[0];
      let temp_company_id = obj_company_detail._id;
      let company_type = obj_company_detail.account_type;

      setcompany_id(temp_company_id);
      setLocationName('')
      setLocationId('')
      setLocationDetail([{}])
      setNumDropdowns(1);
      setCompetitorsGrid([["", "", "", "", ""]]);
      //API call for getting data from DB
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      fetch(
        baseURL + "/get_company_location/" + temp_company_id
        + '?companyNumber=' + encodeURIComponent(temp_company_id.toString()),
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {

          let allTemp = data.res;
          console.log("allTemp");
          console.log(allTemp);
          if (loggedInUserDetail.role_capabilities?.all_modules_access === true) {
            if (allTemp.length > 0) {
              setLocationDetail(allTemp);
            }
          }
          else if (company_type === 'Affiliate' && getUserAccountType(loggedInUserDetail) === 'Corporate') {

            if (allTemp.length > 0) {
              setLocationDetail(allTemp);
            }
          }
          else {
            axios.post(baseURL + "/get_individual_user_details", { 'user_email': loggedInUserDetail.userEmail })
              .then((data) => {
                console.log("data");
                console.log(data);
                if (allTemp.length > 0) {
                  allTemp = allTemp.filter((val) => val !== undefined && data.data[0].location_allocated[val.location_id]);
                  setLocationDetail(allTemp);
                }
              }
              )
          }
        });
    }
  }, [companyName]);

  useEffect(() => {
    const { user, error } = readSessionUser();

    if (error) {
      setLoggedInUserDetail({});
      setcompanyDetail([]);
      return;
    }

    setLoggedInUserDetail(user);
    loadAccessibleCompanies(baseURL, user, 'MinimumRateMapping_Account Access')
      .then(setcompanyDetail)
      .catch(() => setcompanyDetail([]));
  }, []);

  //-------------SIPP Codes based on the selected location-------

  useEffect(() => {
    //API call for getting data from DB
    if (locationName != "") {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };
      fetch(
        baseURL + "/get_all_sipp_code_of_selected_location/" + locationName
        + '?companyNumber=' + encodeURIComponent(company_id.toString()),
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          let allTemp = data;

          setSippCodeList(allTemp);
          setCompetesSippCodeList(allTemp);
        });

    }
  }, [locationName]);

  useEffect(() => {
    setAvailableCarClasses([...selectedSippCodeNameOptions]);
  }, [sippCodeList]);

  const options = [
    { id: 1, value: "option1", label: "Option 1" },
    { id: 2, value: "option2", label: "Option 2" },
    { id: 3, value: "option3", label: "Option 3" },
  ];

  const options1 = [
    { id: 1, value: "Active", label: "Active" },
    { id: 2, value: "IN - Active", label: "In - Active" },
  ];

  const handleAddDropdown = () => {
    setNumDropdowns(numDropdowns + 1);
    let arr1 = [...competitorsGrid];
    arr1.push(["", "", "", "", ""]);
    setCompetitorsGrid(arr1);
  };

  const handleSubmit = async () => {
    if (companyName === "") {
      Swal.fire('Please select Account Name');
      return;
    }

    if (locationName === "") {
      Swal.fire('Please select a Location to proceed');
      return;
    }

    console.log(competitorsGrid);
    let isValid = true;
    const firstRow = competitorsGrid[0];
    if (firstRow[0] === '') {
      Swal.fire(`Please Select a SIPP Code for the first row`);
      return;
    }
    const columnLabels = ["SIPP CODE", "Capped Daily", "Capped Weekly", "Capped X-Day", "Daily Rate"];

    for (let colIndex = 1; colIndex < firstRow.length; colIndex++) {
      const cellValue = firstRow[colIndex];
      if (!cellValue || cellValue.trim() === '') {
        isValid = false;
        Swal.fire(`For Row 1, the ${columnLabels[colIndex]} has an empty value. Please fill it.`);
        return;
      }
    }

    if (isValid) {
      for (let rowIndex = 0; rowIndex < competitorsGrid.length; rowIndex++) {
        const row = competitorsGrid[rowIndex];
        if (row[0]["value"]) {
          for (let colIndex = 1; colIndex < row.length; colIndex++) {
            const cellValue = row[colIndex];
            if (!cellValue || cellValue.trim() === '') {
              isValid = false;
              Swal.fire(`In Row ${rowIndex + 1}, for ${columnLabels[0]} as ${row[0]["value"]} the ${columnLabels[colIndex]} has an empty value. Please fill it.`);
              return;
            }
          }
        }
      }
    }
    const filteredArray = competitorsGrid.filter(innerArray => {
      const firstValue = innerArray[0];
      return firstValue !== undefined && firstValue !== '';
    });
    const body_payload = {
      location_name: locationName,
      location_id: locationId.toString(),
      account_id: company_id.toString(),
      companyNumber: company_id.toString(),
      selected_items: filteredArray,
      from_date: new Date(fromDate).toDateString(),
      to_date: new Date(toDate).toDateString(),
      created_by: loggedInUserDetail.userEmail,
      updated_by: loggedInUserDetail.userEmail,
      created_date: new Date(),
      updated_date: new Date()
    };

    setSaving(true);
    try {
      const response = await axios.post(
        baseURL + "/save_minumum_rate",
        body_payload
      );
      expectExactPayload(response.data, 'success', 'Minimum Rate Mapping save');

      await Swal.fire({
        position: "center",
        icon: "success",
        title: "Submitted Successfully",
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (error) {
      console.error('Unable to save Minimum Rate Mapping:', error);
      await Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Save failed',
        text: requestErrorMessage(
          error,
          'Unable to save Minimum Rate Mapping. Please try again.'
        ),
      });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    let temp_location_id = ''
    if (locationName != "") {
      // setNumDropdowns(1);
      // setCompetitorsGrid([["", "", "","", ""]]);
      temp_location_id = locationDetail.filter((loc) => (loc.location_name === locationName)).map((val) => val.location_id)
      setLocationId(temp_location_id);

      // axios
      //   .get(baseURL + "/get_all_minumum_rate_coll/" + locationName)
      //   .then((res) => {
      //     setNumDropdowns(res.data.selected_items.length);
      //     setCompetitorsGrid(res.data.selected_items);
      //     const usedCarClasses = res.data.selected_items
      //     .filter(row => row[0].value)
      //     .map(row => row[0].value);

      //   const newAvailableCarClasses = selectedSippCodeNameOptions.filter(
      //     option => !usedCarClasses.includes(option.value)
      //   );
      //   // Add back deselected car classes to newAvailableCarClasses
      //   res.data.selected_items.forEach(row => {
      //     if (!row[0].value) {
      //       newAvailableCarClasses.push({ value: row[0].label, label: row[0].label });
      //     }
      //   });
      //   setAvailableCarClasses(newAvailableCarClasses.filter(option => option.value !== 'undefined' ));
      //   console.log("im at inside availableCarClasses");
      //   console.log(availableCarClasses);
      //   });
    }
  }, [locationName, sippCodeList]);

  const handleClear = () => {
    setNumDropdowns(1);
    setCompetitorsGrid([["", "", "", "", ""]]);
    setLocationName("");
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="row pt-2 justify-content-center align-items-center">
          <div className="col-12 col-sm-4 col-lg-2 mb-2 mb-sm-3">
            <label htmlFor="company_name" className="form-label" style={{ marginTop: 5 }}>
              <b>Account Name</b>
            </label>
          </div>

          <div className="col-12 col-sm-8 col-lg-4 mb-3">
            <Select
              value={{ value: companyName, label: (companyName ? companyName : "Select Account Name") }}
              inputId="company_name"
              name="company_name"
              options={companyNameOptions}
              onChange={handleInputChangeCompanyName}
            />
          </div>
        </div>
        <div className="row pt-2 justify-content-center align-items-center">
          <div className="col-12 col-sm-4 col-lg-2 mb-2 mb-sm-3">
            <label htmlFor="locationName" className="form-label" style={{ marginTop: 5 }}>
              <b>Location Name</b>
            </label>
          </div>

          <div className="col-12 col-sm-8 col-lg-4 mb-3">
            <Select
              value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
              inputId="locationName"
              name="locationName"
              options={locationNameOptions}
              onChange={handleInputChangeLocationName}
            />
          </div>
        </div>
        <div className="row g-3 align-items-stretch justify-content-center">
          {/* <label htmlFor="fromDate" className="form-label">
                        <b>From Date</b>
                      </label> */}
          <div className="site-calendar-demo-card col-12 col-lg-4 mb-3">
            <b>From Date</b>
            <Calendar
              fullscreen={false}
              value={moment(fromDate.valueOf())}
              onChange={(value) => {
                setFromDate(value._d);
                setToDate(value._d);
              }}
              disabledDate={(current) => {
                if (toDate && fromDate.valueOf() !== toDate.valueOf()) {
                  return current && (current.valueOf() > toDate.valueOf() + 1 * 24 * 60 * 60) || current.valueOf() < new Date().valueOf() - 1 * 24 * 60 * 60;
                } else {
                  return current && current.valueOf() < new Date().valueOf() - 1 * 24 * 60 * 60;
                }
              }}
            />
          </div>
          {/* <label htmlFor="toDate" className="form-label">
                        <b>To Date</b>
                      </label> */}
          <div className="site-calendar-demo-card col-12 col-lg-4 mb-3">
            <b>To Date</b>
            <Calendar
              fullscreen={false}
              value={moment(toDate.valueOf())}
              onChange={(value) => {
                setToDate(value._d);
              }}
              disabledDate={(current) => {
                if (fromDate) {
                  return current && current.valueOf() < fromDate.valueOf();
                } else {
                  return current && current.valueOf() < new Date().valueOf() - 1 * 24 * 60 * 60;
                }
              }}
            />
          </div>
          <div className="col-12 col-lg-auto mb-3 d-flex align-items-center justify-content-center">
            <button
              type="submit"
              className="btn btn-success"
              onClick={getTheDataByDateandLocation}
              style={{
                backgroundColor: " green",
              }}
            >
              Fetch
            </button>
          </div>
        </div>


        <div
          className=" mt-5"
          style={{ border: "5px solid black", padding: "10px", marginLeft: "10px", marginRight: "10px" }}
        >
          <div className="row mt-5 g-3 align-items-end">
            <div className="col-12 col-lg-2">
              <div className="rms-heading text-center"><b>SIPP CODE</b></div>
            </div>
            {/* <div className="col-md-2">
              <div className="rms-heading text-center"><b>Competes SIPP Code</b></div>
            </div> */}
            <div className="col-12 col-lg-7">
              <div className="rms-capped-rates text-center"><b>Capped Rates</b></div>
              <div
                className="row"
                style={{
                  borderRight: "3px solid blue",
                  borderLeft: "3px solid blue",
                    marginTop: "19px"
                }}
              >
                <div className="col-12 col-md-4" >
                  <div className="rms-heading text-center">
                    Capped Daily <span className="blue-required"> *</span>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="rms-heading text-center">
                    Capped Weekly<span className="blue-required"> *</span>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="rms-heading text-center">
                    Capped X Day<span className="blue-required"> *</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="rms-capped-rates1 text-center"><b>If Competitor Rates are not Present</b>
              </div>
              <div className="rms-heading pt-2 text-center">
                Daily Rate<span className="blue-required"> *</span>
              </div>
            </div>
            {/* <div className="col-md-1">
              <div className="rms-heading text-center"><b>Spl Adjustment</b></div>
            </div> */}
            {/* <div className="col-md-2">
              <div className="rms-heading text-center"><b>Status</b></div>
            </div> */}
          </div>
          {[...Array(numDropdowns)].map((_, i) => (
            <div className="row pt-3 g-3 align-items-center">
              <div className="col-12 col-lg-2">
                <Select
                  value={{
                    value: competitorsGrid[i][0]["value"],
                    label: competitorsGrid[i][0]["value"]
                      ? competitorsGrid[i][0]["value"]
                      : "Select SIPP Code",
                  }}
                  options={availableCarClasses}
                  onChange={(e) => handleInputChangeSippCode(e, i)}
                />
              </div>
              {/* <div className="col-md-2">
                <Select
                  value={{
                    value: competitorsGrid[i][1]["value"],
                    label: competitorsGrid[i][1]["value"]
                      ? competitorsGrid[i][1]["value"]
                      : "Select Competate SIPP",
                  }}
                  options={selectedCompetesSippCodeNameOptions}
                  // onChange={}
                  onChange={(e) => handleInputChangeCompetesSippCode(e, i)}
                />
              </div> */}
              <div className="col-12 col-lg-7">
                <div
                  className="row"
                  style={{
                    borderRight: "3px solid blue",
                    borderLeft: "3px solid blue",
                    // marginLeft:"10px",
                    // marginRight:"60px"
                    marginLeft: 0,
                    marginRight: 0
                  }}
                >
                  <div className="col-12 col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      value={competitorsGrid[i][1]}
                      onChange={(e) =>
                        handleInputChangeCappedDaily(e.target.value, i)
                      }
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      value={competitorsGrid[i][2]}
                      onChange={(e) =>
                        handleInputChangeCappedWeekly(e.target.value, i)
                      }
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      value={competitorsGrid[i][3]}
                      onChange={(e) =>
                        handleInputChangeCappedXDay(e.target.value, i)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <input
                  type="number"
                  className="form-control"
                  value={competitorsGrid[i][4]}
                  onChange={(e) =>
                    handleInputChangeDailyRate(e.target.value, i)
                  }
                />
              </div>
              {/* <div className="col-md-1">
                <input
                  type="text"
                  className="form-control"
                  value={competitorsGrid[i][5]}
                  onChange={(e) =>
                    handleInputChangeSplAdjustment(e.target.value, i)
                  }
                />{" "}
              </div> */}
              {/* <div className="col-md-2">
                <Select
                  value={{
                    value: competitorsGrid[i][6]["value"],
                    label: competitorsGrid[i][6]["value"]
                      ? competitorsGrid[i][6]["value"]
                      : "Select Status",
                  }}
                  options={options1}
                  // onChange={}
                  onChange={(e) => handleInputChangeStatus(e, i)}
                />
              </div> */}
            </div>
          ))}

          { 
          accessType === 'View' ? "" :
          <>
          <button
            type="submit"
            className="btn btn-success"
            onClick={handleAddDropdown}
            style={{
              maxWidth: "100px",
              maxHeight: "100px",
              marginTop: "2em",
              backgroundColor: " green",
            }}
          >
            Add
          </button>
          <div className="row pt-3 g-3 align-items-center">
            <div className="col-12 col-md-6 d-flex flex-wrap gap-2">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={saving}
                style={{ marginRight: "10px" }}
                onClick={handleSubmit}
              >
                {saving ? 'Saving...' : 'Submit'}
              </button>
              <button
                className="btn btn-danger"
                type="cancel"
                style={{}}
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
            <div className="col-12 col-md-6">
              <div className="float-end" style={{ color: "blue" }}>
                (*) This Fields must be Mandatory
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-md-2"></div>
          </div>
          </>
}
        </div>
        <div className="row pt-3">
          <div className="col-md-3">
            <div
              className="row"
              style={{
                borderRight: "3px solid blue",
                borderLeft: "3px solid blue",
              }}
            ></div>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-md-3">
            <div
              className="row"
              style={{
                borderRight: "3px solid blue",
                borderLeft: "3px solid blue",
              }}
            ></div>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-md-3">
            <div
              className="row"
              style={{
                borderRight: "3px solid blue",
                borderLeft: "3px solid blue",
              }}
            ></div>
          </div>
        </div>
        <div className="col-md-3">
          <div
            className="row"
            style={{
              borderRight: "3px solid blue",
              borderLeft: "3px solid blue",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
